{
	"type": "line",
	"minzoom": 8,
	"filter": ["==", ["get", "sz_type"], "School"],
	"layout": {},
	"paint": {
		"line-color": [
			"match",
			["get", "sz_speed"],
			"10 km/h",
			"#f789d8",
			"20 km/h",
			"#6b6bd6",
			"30 km/h",
			"#6e0e21",
			"40 km/h",
			"#a7c636",
			"50 km/h",
			"#999999",
			"60 km/h",
			"#f51400",
			"70 km/h",
			"#ffde3e",
			"80 km/h",
			"#fc921f",
			"90 km/h",
			"#3caf99",
			"100 km/h",
			"#149ece",
			"110 km/h",
			"#b7814a",
			"#ddd"
		],
		"line-width": ["interpolate", ["linear"], ["zoom"], 9, 3, 18, 21],
		"line-dasharray": ["literal", [0.1, 0.1]],
		"line-opacity": 0.6
	}
}
